import React, { useCallback, useEffect, useRef, useState } from 'react'
import VideoPlayer from '../4lPlayer'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { GetVideoDetails } from 'src/redux/actions'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Center } from '@chakra-ui/react'
import { LearnTabFooter } from '../CourseDetail/LearnTabFooter'
import CardLoader from '../CardLoader'
import Explore from 'src/Container/Explore'
import "./videos.css"
import { ScrollDownSvg } from 'src/asset/SvgContainer/Svgs'
import { isMobile } from '../CourseDetail/Practice/Util'

const Videos = () => {

  const playerRef = useRef(null)
  const { slug } = useParams()
  const { videoDetails } = useSelector(store => store.mainReducer)
  const [isPlaying, setIsPlaying] = useState(false)
  const [isMuted, setIsMuted] = useState(false)
  const [played, setPlayed] = useState(0) // Track progress
  const dispatch = useDispatch()

  const footerRef = useRef(null)
  const scrollButtonRef = useRef(null)
  const lastScrollY = useRef(0)

  useEffect(() => {
    if (slug) {
      dispatch(GetVideoDetails(slug))
    }
  }, [slug, dispatch])

  const [progress, setProgress] = useState(0)
  const isFourLVideo = () => videoDetails?.type === '4L'

  const handleScroll = useCallback(() => {
    requestAnimationFrame(() => {
      const y = window.scrollY
      const isScrollingDown = y > lastScrollY.current
      const isPastThreshold = y > 200
      const btn = scrollButtonRef.current
      const footer = footerRef.current
      btn?.classList.toggle('hidden', isPastThreshold || isScrollingDown)
      footer?.classList.toggle('hide', isPastThreshold)
      lastScrollY.current = y
    })
  }, [])

  const handleScrollDown = useCallback(() => {
    window.scrollBy({ top: 400, behavior: 'smooth' })
    scrollButtonRef.current?.classList.add('hidden')
    footerRef.current?.classList.add('hide')
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll, { passive: true })
  }, [handleScroll])


  if (!videoDetails) return (
    <Center height="60vh" p={6} textAlign="center">
      <Box
        w="full"
        maxW={'820px'}
      >
        <CardLoader
          height={'526px'}
          width="100%"
        />
      </Box>
    </Center>
  );

  return (
    <Box mt={2}>
      <VideoPlayer
        isPlaying={isPlaying}
        setIsPlaying={setIsPlaying}
        subtitles={videoDetails?.subtitle}
        videoSrc={videoDetails?.video}
        setProgress={setProgress}
        isMuted={isMuted}
        setIsMuted={setIsMuted}
        ref={playerRef}
        played={played}
        setPlayed={setPlayed}
      />
      <Explore />
      <span
        className="scroll-button"
        ref={scrollButtonRef}
        onClick={handleScrollDown}
      >
        <ScrollDownSvg height={isMobile ? 28 : 38} width={isMobile ? 28 : 38} />
      </span>

      <div className="footer-wrapper" ref={footerRef}>
        <LearnTabFooter
          videoControlsOnly
          isFourLVideo={isFourLVideo()}
          playerRef={playerRef}
          videoProgress={progress}
          editUri={`app/entertainmentVideos?slug=${slug}`}
          playingProps={{
            isPlaying,
            setIsPlaying,
            played,
            setPlayed,
            setIsMuted,
            isMuted,
          }}
        />
      </div>
    </Box>
  )
}

export default Videos
